<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

@if (configReleaseBannerMessage() && !releaseBannerDismissed()) {
  <p-message severity="info"
             [closable]="true"
             (onClose)="releaseBannerDismissed.set(true)"
             [text]="configReleaseBannerMessage()"
             styleClass="esci-app-banner"></p-message>
}
@if (scheduledReleaseBannerMessage() && !scheduledReleaseBannerDismissed()) {
  <p-message [severity]="scheduledReleaseSeverity()"
             [closable]="true"
             (onClose)="scheduledReleaseBannerDismissed.set(true)"
             [text]="scheduledReleaseBannerMessage()"
             styleClass="esci-app-banner"></p-message>
}
<navigation [navMenuItems]="navItems"></navigation>
<div class="esci-toast-dock">
  @if (messageService.showCloseAll()) {
    <button type="button" class="esci-toast-close-all" (click)="messageService.clear()">Close All</button>
  }
  <p-toast key="global" (onClose)="messageService.onToastClosed()"></p-toast>
</div>
<user-session-timeout></user-session-timeout>
